import { relations, sql } from 'drizzle-orm'
import { index, pgTable, text, timestamp, uuid } from 'drizzle-orm/pg-core'
import { createInsertSchema, createSelectSchema, createUpdateSchema } from 'drizzle-zod'

import { user } from '../auth'
import { Lesson } from '../content'
import { File } from '../file'
import { LearnProgress } from './tracker'

export const InClassAttachment = pgTable(
  'in_class_attachment',
  {
    id: uuid().primaryKey().defaultRandom(),
    learnProgressId: uuid()
      .notNull()
      .references(() => LearnProgress.id, { onDelete: 'cascade' }),
    lessonId: uuid()
      .notNull()
      .references(() => Lesson.id, { onDelete: 'cascade' }),
    fileId: uuid()
      .notNull()
      .references(() => File.id, { onDelete: 'cascade' }),
    userId: text()
      .notNull()
      .references(() => user.id, { onDelete: 'cascade' }),
    createdAt: timestamp({ mode: 'date', withTimezone: true }).defaultNow().notNull(),
    updatedAt: timestamp({ mode: 'date', withTimezone: true }).$onUpdateFn(() => sql`now()`),
  },
  (t) => [
    index('idx_in_class_attachment_progress').on(t.learnProgressId),
    index('idx_in_class_attachment_user').on(t.userId),
  ],
)

export const inClassAttachmentRelations = relations(InClassAttachment, ({ one }) => ({
  learnProgress: one(LearnProgress, {
    fields: [InClassAttachment.learnProgressId],
    references: [LearnProgress.id],
  }),
  lesson: one(Lesson, {
    fields: [InClassAttachment.lessonId],
    references: [Lesson.id],
  }),
  file: one(File, {
    fields: [InClassAttachment.fileId],
    references: [File.id],
  }),
  user: one(user, {
    fields: [InClassAttachment.userId],
    references: [user.id],
  }),
}))

export const InsertInClassAttachmentSchema = createInsertSchema(InClassAttachment).omit({
  id: true,
  createdAt: true,
  updatedAt: true,
})
export const UpdateInClassAttachmentSchema = createUpdateSchema(InClassAttachment).partial().omit({
  id: true,
  learnProgressId: true,
  lessonId: true,
  userId: true,
  createdAt: true,
  updatedAt: true,
})
export const SelectInClassAttachmentSchema = createSelectSchema(InClassAttachment)

export type InsertInClassAttachment = typeof InClassAttachment.$inferInsert
export type SelectInClassAttachment = typeof InClassAttachment.$inferSelect
